import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e617c7b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<rect x=\"0.5\" y=\"0.5\" width=\"100%\" height=\"100%\" stroke=\"var(--white)\" data-v-e617c7b2></rect><rect x=\"0.5\" y=\"0.5\" width=\"100%\" height=\"100%\" stroke=\"url(#InsetBorder-gradient)\" data-v-e617c7b2></rect><defs data-v-e617c7b2><linearGradient id=\"InsetBorder-gradient\" x1=\"255.743\" y1=\"-255.612\" x2=\"1455.95\" y2=\"612.43\" gradientUnits=\"userSpaceOnUse\" data-v-e617c7b2><stop stop-color=\"#F5AAE0\" data-v-e617c7b2></stop><stop offset=\"0.484375\" stop-color=\"#A47CDA\" stop-opacity=\"0.820781\" data-v-e617c7b2></stop><stop offset=\"1\" stop-color=\"#4D4BD2\" stop-opacity=\"0.63\" data-v-e617c7b2></stop></linearGradient></defs>", 3)
const _hoisted_4 = [
  _hoisted_1
]

import { gsap } from 'gsap'
import { setFPS } from '@/utils/FrameToTime'



import { defineComponent, onMounted, ref } from 'vue'

const __default__ = defineComponent({})

function setup(__props) {

const frames = setFPS(60)
const root = ref<HTMLDivElement>(null)
const border = ref<SVGElement>(null)

onMounted(() => {
  onEnter()
})

const onEnter = () => {

  const width = root.value.offsetWidth
  const height = root.value.offsetHeight
  const d = width * 2 + height * 2
  
  const tl = gsap.timeline({
    delay: 1
  })
  tl
    .fromTo(border.value, {
      strokeDasharray: `0 ${0.7*d}`,
      strokeDashoffset: d*0.08
    }, {
      strokeDasharray: `${0.9*d} 0 `,
      duration: 1.7,
      ease: 'quint.inOut'
    })

}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref: (_value, _refs) => {
      _refs['root'] = _value
      root.value = _value
    },
    class: "InsetBorder"
  }, [
    (_openBlock(), _createElementBlock("svg", {
      ref: (_value, _refs) => {
        _refs['border'] = _value
        border.value = _value
      },
      fill: "none"
    }, _hoisted_4, 512))
  ], 512))
}
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup})